
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "selection",
    "selectAll",
    "listSelectAll",
    "selectionCount",
    "emailModal",
    "emailInput",
    "emailFormat",
    "emailSubmit"
  ]

  connect() {
    console.log("hi lists")
    // Dynamic rows are only used on the edit/new form.
    if (this.element.querySelector("#specification-list-row-template")) {
      this.initializeRows()
    }

    this.updateSelection()
  }

  // --------------------------------------------------
  // Dynamic specification rows (existing functionality)
  // --------------------------------------------------

  initializeRows() {
    this.index = this.element.querySelectorAll("tr").length - 1
    this.addNewRow()

    this.element.addEventListener("specification-list-row:modified", (event) => {
      this.addRowIfNeeded(event)
    })
  }

  addRowIfNeeded(event) {
    const row = event.target
    const isNew = row.dataset.storageState === "new"
    const modState = row.dataset.modState

    if (isNew && modState === "modified") {
      this.addNewRow()
    }
  }

  addNewRow() {
    const template = this.element.querySelector("#specification-list-row-template")
    const clone = template.cloneNode(true)

    clone.removeAttribute("id")
    this.index += 1

    // Replace INDEX in name and id.
    clone.querySelectorAll("[name]").forEach((el) => {
      el.name = el.name.replace(/\[INDEX\]/g, `[${this.index}]`)
    })

    clone.querySelectorAll("[id]").forEach((el) => {
      el.id = el.id.replace(/INDEX/g, `${this.index}`)
    })

    // Reset modification and storage state.
    clone.dataset.storageState = "new"
    clone.dataset.modState = "unmodified"

    // Reset form inputs.
    clone.querySelectorAll("input").forEach((el) => {
      el.value = ""
      el.disabled = false
    })

    // Disable deletion until the row has been modified.
    const deleteButton = clone.querySelector("button")

    if (deleteButton) {
      deleteButton.disabled = true
      deleteButton.textContent = "delete"
    }

    this.element.appendChild(clone)
  }

  removeRow(rowElement) {
    rowElement.remove()
  }

  // --------------------------------------------------
  // Index page: expand / collapse
  // --------------------------------------------------

  toggle(event) {
    console.log("hi toggle")
    const button = event.currentTarget
    const content = document.getElementById(button.getAttribute("aria-controls"))

    if (!content) return

    const expanded = button.getAttribute("aria-expanded") === "true"

    content.hidden = expanded
    button.setAttribute("aria-expanded", String(!expanded))
    button.textContent = expanded ? "+" : "−"
  }

  // --------------------------------------------------
  // Index page: copy specification value
  // --------------------------------------------------

  async copy(event) {
    const button = event.currentTarget

    try {
      await navigator.clipboard.writeText(button.dataset.value || "")

      button.textContent = "Copied!"
      button.disabled = true

      setTimeout(() => {
        if (!button.isConnected) return

        button.textContent = "Copy Value"
        button.disabled = false
      }, 1500)
    } catch (error) {
      console.error("Failed to copy specification:", error)
    }
  }

  // --------------------------------------------------
  // Index page: specification selection
  // --------------------------------------------------

  selectAll(event) {
    const checked = event.currentTarget.checked

    this.selectionTargets.forEach((checkbox) => {
      checkbox.checked = checked
    })

    this.updateSelection()
  }

  selectList(event) {
    const checkbox = event.currentTarget
    const listId = checkbox.dataset.listId
    const list = document.getElementById(`specification-list-${listId}`)

    if (!list) return

    list.querySelectorAll('input[name="specification_ids[]"]').forEach((input) => {
      input.checked = checkbox.checked
    })

    this.updateSelection()
  }

  updateSelection() {
    if (!this.hasSelectionTarget) return

    const total = this.selectionTargets.length
    const selected = this.selectionTargets.filter((checkbox) => checkbox.checked).length

    if (this.hasSelectionCountTarget) {
      this.selectionCountTarget.textContent = `${selected} of ${total} selected`
    }

    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = selected === total && total > 0
      this.selectAllTarget.indeterminate = selected > 0 && selected < total
    }

    this.listSelectAllTargets.forEach((checkbox) => {
      const list = document.getElementById(
        `specification-list-${checkbox.dataset.listId}`
      )

      if (!list) return

      const inputs = Array.from(
        list.querySelectorAll('input[name="specification_ids[]"]')
      )

      const checked = inputs.filter((input) => input.checked).length

      checkbox.checked = inputs.length > 0 && checked === inputs.length
      checkbox.indeterminate = checked > 0 && checked < inputs.length
    })
  }
}
